export const destinationLabels = {
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  files: "Dosya / bulut",
  photos: "Fotoğraflar",
  other: "Diğer uygulama",
  unknown: "Hedef bilinmiyor",
};
export const categoryLabels = {
  friday: "Cuma",
  night: "Kandil",
  eid: "Bayram",
};
export const artworkLabels = {
  emerald: "Zümrüt",
  lantern: "Kandil ışığı",
  floral: "Bahar çiçekleri",
  celebration: "Bayram sevinci",
  turquoise: "Turkuaz çini",
  ivory: "Fildişi",
  tulip: "Lale bahçesi",
  rose: "Gül ebrusu",
  celestial: "Gece göğü",
  olive: "Zeytin dalı",
  sand: "Altın desen",
  dawn: "İstanbul sabahı",
};
export const statusLabels = {
  started: "Hazırlanıyor",
  opened: "Sonuç bildirilmedi",
  selected: "Hedef seçildi",
  completed: "Tamamlandı (iOS)",
  cancelled: "İptal edildi",
  failed: "Hata oluştu",
};
export const statusColors = {
  started: "default",
  opened: "warning",
  selected: "info",
  completed: "success",
  cancelled: "default",
  failed: "error",
};
export const formatShareTime = (value) =>
  new Intl.DateTimeFormat("tr-TR", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: "Europe/Istanbul",
  }).format(new Date(value));

export const initialFilters = () => {
  const today = new Date(Date.now() + 3 * 3600000);
  return {
    from: new Date(today.getTime() - 29 * 86400000).toISOString().slice(0, 10),
    to: today.toISOString().slice(0, 10),
    destination: "all",
    platform: "all",
    category: "all",
    status: "all",
    search: "",
  };
};

export const dailySeries = (daily, from, to) => {
  const indexed = new Map(daily.map((item) => [item._id, item]));
  const results = [];
  for (
    let day = Date.parse(from);
    day <= Date.parse(to) && results.length < 366;
    day += 86400000
  ) {
    const key = new Date(day).toISOString().slice(0, 10);
    results.push({ date: key, attempts: 0, actions: 0, ...indexed.get(key) });
  }
  return results;
};
